import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { PanelDirective } from '../../directives/panel.directive';
import { TranslatePipe } from '../../filters/translate.pipe';
import RoutingService from '../../services/routing.service';
import { CardEmployeeTrainingProgramComponent } from '../../components/card-employee-training-program/card-employee-training-program.component';

@Component({
    standalone: true,
    selector: 'create-employee-training-program',
    templateUrl: './create-employee-training-program.component.html',
    imports: [ CommonModule, TranslatePipe, CardEmployeeTrainingProgramComponent, PanelDirective ]
})
export default class CreateEmployeeTrainingProgramComponent implements OnInit {
    private routingService: RoutingService = inject(RoutingService);

    vm: any = undefined;

    constructor(private route: ActivatedRoute) {
        this.vm = this;
    }

    ngOnInit() {
        this.routingService.validateAccess('employees').then(() => {});
        this.vm.trainingProgramCode = this.route.snapshot.paramMap.get('trainingProgramCode');
    }
}
